// 'use strict';
var mapUrl = "";
// import {diffEvn} from '../config/diffEvn'
// 打包用 path.json, 本地运行可用 path_ecc.json
/**
 * 打包时需要修改66行appversion版本号日期 改成当前年月日
 * 打包用 path.json, 本地运行可用 path_ecc.json
 */
import { allUrl } from '../config/diffEvn';
// const {NODE_ENV} = process.env;
// var path = diffEvn[NODE_ENV].configJsonName;
// console.log(path);
// console.log(NODE_ENV);
// console.log(location);
// const ispro=NODE_ENV==='pro';
// const urlArr=['serviceUrl','servletServiceUrl','mapUrl']
 // 配置生产环境 的 path
//  if (process.env.NODE_ENV === 'production') {
//    path = "n.json";
//  } else {
    // path = "pro.json";
    // path = "test.json";

//   // 宁本地
//    path = "pro.json";
//    // path = "path_demo.json";
// //    path = "path_106.json";
//    // path = "path_ecc.json";
//    // path = "path_eccqa.json";
//    // path = "path6.16.json";
//  }

const Store = {
	get: function(key) {
		return window.localStorage[key];
	},
	set: function(key, value) {
		window.localStorage[key] = value;
	},
	getBool: function(key) {
		return window.localStorage[key] === 'true' ? true : false;
	},
	deleted: function(key) {
		window.localStorage.removeItem(key);
	},
	get_ServiceAddress:function(){
		$.getJSON(path,function(data){
			localStorage.setItem("serviceUrl",data.ServiceAddress);
		});
	},
	get_ServletServiceAddress:function(){
		$.getJSON(path,function(data){
			localStorage.setItem("servletServiceUrl",data.ServletServiceAddress);
		});
	},
	get_newsamAddress:function(){
		$.getJSON(path,function(data){
			localStorage.setItem("newsamUrl",data.newsamUrl);
		});
	},
	get_tokenVerify:function(){
		$.getJSON(path,function(data){
			localStorage.setItem("tokenUrl",data.TokenVerify);
		});
	},
	get_portletData:function(){
		return "http://localhost:3000/portlets.json";
	},
	get_mapUrl:function(){
		$.getJSON(path,function(data){
			localStorage.setItem("mapUrl",data.mapUrl);
		});
	},
	// getConfigJson: function(callback) {
	// 	$.getJSON(path,function(data){
	// 		callback && callback(data);
	// 	});
	// },
	getConfigJson: function(callback) {
		callback && callback(allUrl);
	},
}

export default Store;
